import React from 'react';
import styled from 'styled-components';

import Section from '../basic/layouts/Section';
import HubspotForm from '../PardotForm/HubspotForm';

import constants from '../../constants';

const { formId, salesForm } = constants;

const FormWrapper = styled.div`
	box-shadow: 0px 4px 64px rgb(46 64 100 / 10%);
	padding: 80px;
`;

const StandaloneHubspotForm = ({ header, subheader, altFormId, id }) => {
	return (
		<Section
			header={header || salesForm.header}
			subheader={subheader || salesForm.subheader}
			centerHeader
			id={id}
		>
			<FormWrapper>
				<HubspotForm formId={altFormId || formId.salesForm} />
			</FormWrapper>
		</Section>
	);
};

export default StandaloneHubspotForm;
